document.addEventListener('DOMContentLoaded', function () {
    const postsContainer = document.getElementById('posts-container');
    if (!postsContainer) {
        return;
    }


    const apiKey = postsContainer.dataset.apiKey;
    const apiUrl = postsContainer.dataset.apiUrl;

    const filterButtonsContainer = document.querySelector('.filter-buttons');
    if (!filterButtonsContainer) {
        return;
    }

    const rawFilterTags = filterButtonsContainer.dataset.filterTags || '';
    const filterTags = rawFilterTags
        .split(',')
        .map(tag => tag.trim())
        .filter(Boolean);

    const featuredIcon = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.49365 4.58752C3.53115 6.03752 2.74365 7.70002 2.74365 9.25002C2.74365 10.6424 3.29678 11.9778 4.28134 12.9623C5.26591 13.9469 6.60127 14.5 7.99365 14.5C9.38604 14.5 10.7214 13.9469 11.706 12.9623C12.6905 11.9778 13.2437 10.6424 13.2437 9.25002C13.2437 6.00002 10.9937 3.50002 9.16865 1.68127L6.99365 6.25002L4.49365 4.58752Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>`;

    // Create "All" reset button (accessible)
    const resetBtn = document.createElement('button');
    resetBtn.classList.add('filter-btn');
    resetBtn.classList.add('bfh-filter-button');
    resetBtn.classList.add('active');
    resetBtn.type = 'button';
    resetBtn.dataset.filter = 'all';
    resetBtn.textContent = 'Alle';
    resetBtn.setAttribute('aria-pressed', 'true');
    resetBtn.setAttribute('aria-label', 'Alle Beiträge anzeigen');
    filterButtonsContainer.appendChild(resetBtn);

    // Create filter buttons based on custom filter tags (accessible)
    filterTags.forEach(tag => {
        const filterBtn = document.createElement('button');
        filterBtn.classList.add('filter-btn');
        filterBtn.classList.add('bfh-filter-button');
        filterBtn.type = 'button';
        filterBtn.dataset.filter = tag.toLowerCase();
        filterBtn.textContent = tag;
        filterBtn.setAttribute('aria-pressed', 'false');
        filterBtn.setAttribute('aria-label', `Beiträge mit Tag ${tag} anzeigen`);
        filterButtonsContainer.appendChild(filterBtn);
    });

    // Attach click listeners after buttons are created
    document.querySelectorAll('.filter-btn').forEach(button => {
        button.addEventListener('click', function () {
            const tagSlug = this.dataset.filter;

            // Update active/pressed state
            document.querySelectorAll('.filter-btn').forEach(btn => {
                btn.classList.remove('active');
                btn.setAttribute('aria-pressed', 'false');
            });
            this.classList.add('active');
            this.setAttribute('aria-pressed', 'true');

            // Build API URL (all posts or filtered by tag)
            let url = `${apiUrl}/ghost/api/content/posts/?include=tags,authors&limit=all&key=${apiKey}`;
            if (tagSlug !== 'all') {
                url += `&filter=tag:${tagSlug}`;
            }

            // Fetch posts from Ghost API
            fetch(url)
                .then(res => res.json())
                .then(data => {
                    const postFeed = document.getElementById('post-feed');

                    if (data.posts && data.posts.length > 0) {
                        postFeed.innerHTML = data.posts.map(post => {
                            const primary = post.primary_tag || (post.tags && post.tags[0]);
                            let html = `<article class="post-card post${post.featured ? ' post-card-featured' : ''} ${post.feature_image ? '' : 'no-image'}">`;

                            if (post.feature_image) {
                                html += '<a class="post-card-image-link" href="' + post.url + '">' +
                                    '<img class="post-card-image" src="' + (post.feature_image || '') + '" alt="' + (post.feature_image_alt || post.title) + '" loading="lazy" />' +
                                    '</a>';
                            }

                            html += '<div class="post-card-content">' +
                                '<a class="post-card-content-link" href="' + post.url + '">' +
                                '<header class="post-card-header"><h2 class="post-card-title">';

                            if (primary) {
                                html += '<span class="post-card-primary-tag">' + primary.name + '</span><span class="bfh-slash"> /</span><br>';
                            }

                            html += post.title + '</h2></header>';

                            if (post.excerpt) {
                                html += '<div class="post-card-excerpt"><time class="post-card-date" datetime="' + post.published_at + '">' + new Date(post.published_at).toLocaleDateString('de-CH') + '</time> <span class="bfh-slash"> /</span> ' + post.excerpt + '</div>';
                            }

                            html += '</a>' +
                                '<footer class="post-card-meta">' + (post.authors ? post.authors.map(a => a.name).join(', ') : '');

                            if (post.reading_time) {
                                html += '<span class="bfh-slash"> /</span><span class="post-card-meta-length">' + post.reading_time + 'min read</span>';
                            }

                            if (post.featured) {
                                html += '<span class="post-card-featured">' + featuredIcon + ' Featured' + '</span>';
                            }

                            html += '</footer>';

                            html += '</div></article>';

                            return html;
                        }).join('');
                    } else {
                        postFeed.innerHTML = '<p>No posts found for this tag.</p>';
                    }
                })
                .catch(error => console.error('Error fetching posts:', error));
        });
    });
});